import { AxiosRequestConfig } from 'axios';
import https from 'https';
import { STORAGE } from '../constants';
import api from '../utils/api';
import apiSinister from '~/utils/apiSinister';
import apiSSO from '~/utils/sso';
import apiAssist from '~/utils/apiAssist';

const urls = [
  '/auth/forgot-password',
  '/auth/signin',
  '/reset-password/confirm/',
  '/users/check',
  '/politica_privacidade_usuario/get_politica_privacidade_vigente',
];

api.interceptors.request.use(
  (request: AxiosRequestConfig) => {
    if (request.url && !urls.includes(request.url)) {
      const token = localStorage.getItem(`${STORAGE}:token`);
      request.headers = {
        Authorization: `Bearer ${token}`,
      };

      request.httpsAgent = new https.Agent({
        rejectUnauthorized: true,
      });
    }

    return request;
  },
  err => {
    return Promise.reject(err);
  },
);

apiSinister.interceptors.request.use(
  (request: AxiosRequestConfig) => {
    if (request.url && !urls.includes(request.url)) {
      const token = localStorage.getItem(`${STORAGE}:token`);
      request.headers = {
        Authorization: `Bearer ${token}`,
      };

      request.httpsAgent = new https.Agent({
        rejectUnauthorized: true,
      });
    }

    return request;
  },
  err => {
    return Promise.reject(err);
  },
);

apiSSO.interceptors.request.use(
  (request: AxiosRequestConfig) => {
    if (request.url && !urls.includes(request.url)) {
      const token = localStorage.getItem(`${STORAGE}:token`);
      request.headers = {
        Authorization: `Bearer ${token}`,
      };

      request.httpsAgent = new https.Agent({
        rejectUnauthorized: true,
      });
    }

    return request;
  },
  err => {
    return Promise.reject(err);
  },
);

apiAssist.interceptors.request.use(
  (request: AxiosRequestConfig) => {
    if (request.url && !urls.includes(request.url)) {
      const token = localStorage.getItem(`${STORAGE}:token`);
      request.headers = {
        Authorization: `Bearer ${token}`,
      };

      request.httpsAgent = new https.Agent({
        rejectUnauthorized: true,
      });
    }

    return request;
  },
  err => {
    return Promise.reject(err);
  },
);
